export default {
  touch(state, payload) {
    state.touch = payload;
    return state;
  },
  setState(state, payload) {
    state[payload.property] = payload.value;
    return state;
  },
  setLanguage(state, payload) {
    state.langCode = payload;
    return state;
  },
  setStrings(state, payload) {
    state.strings = payload;
    return state;
  },
  setLoginError(state, payload) {
    state.loginError = payload;
    return state;
  },
  setItemLangTree(state, payload) {
    state.item_lang_tree = { ...payload };
    return state;
  },
  setPublications(state, payload) {
    state.publications = [...payload];
    return state;
  },
  setCategories(state, payload) {
    state.categories = { ...payload };
    return state;
  },
  setScreenSpecs(state, payload) {
    state.global_screen_specs = payload;
    return state;
  },
  getParentPath(state, payload) {
    state.item_parentpath = payload;
    // set root path to be used in placeholders
    if (!state.root_path?.item && payload?.item) {
      state.root_path.children = [];
      state.root_path.item = payload.item;
      state.root_path.itemLang = payload.itemLang;
    }
    return state;
  },
  setRootPath(state, payload) {
    state.root_path.children = [];
    state.root_path.item = payload.item;
    state.root_path.itemLang = payload.itemLang;
  },
  // ------ Property Filter ---------//
  setPanelControlDefs(state, payload) {
    state.panel_control_defs = [...payload];
    return state;
  },
  setControlDefData(state, payload) {
    state.control_def_data_array = [...payload];
    return state;
  },
  setPanelJSonData(state, payload) {
    state.panel_control_defs_json = payload;
    return state;
  },
  setPropertyFilterState(state, payload) {
    state.property_filter_state = payload;
    return state;
  },
  // --------------------------------//
  getHelpsetTOC(state, payload) {
    state.item_toc = payload;
    return state;
  },
  topicHtmlBody(state, payload) {
    state.topic_html_body = payload;
    return state;
  },
  search(state, payload) {
    state.search_results = payload;
    return state;
  },
  setPubSearchResults(state, payload) {
    state.pub_search_results = [...payload];
    return state;
  },
  addOrderItem(state, payload) {
    state.partcart = payload;
    return state;
  },
  setShortcutExtId(state, payload) {
    state.shortcut_extId = payload;
    return state;
  },
};
